import { FunctionComponent } from 'react';
import { Outlet, useLoaderData, useParams } from 'react-router';
import { LoaderWithConfig, primeSwrCache } from '../common/utils/loaderFactory';
import MobileNavigation from '../features/mobileNavigation/MobileNavigation';
import Navigation from '../features/navigation/Navigation';
import { PropertyAssociationList } from '../features/propertyAssociation/models/PropertyAssociationList';
import { PropertyAssociationProvider } from '../features/propertyAssociation/PropertyAssociationContext';
import { getPropertyAssociationsAsync, usePropertyAssociations } from '../features/propertyAssociation/propertyAssociationService';
import SubscriptionBanner from '../features/subscription/SubscriptionBanner';

export const appLoader: LoaderWithConfig<PropertyAssociationList> = async (_, config) => {
    const data = await getPropertyAssociationsAsync(config.apiBaseUrl);

    // Prime SWR cache with loader data
    primeSwrCache(`${config.apiBaseUrl}/propertyassociations`, data);

    return data;
};

export const AppLayout: FunctionComponent = () => {
    const loaderData = useLoaderData<PropertyAssociationList>();
    const { propertyAssociations, isAdmin } = usePropertyAssociations(loaderData);
    const params = useParams();
    const isGuest = params.propertyAssociationId ? (propertyAssociations.find((pa) => pa.propertyAssociationId === params.propertyAssociationId)?.isGuest ?? true) : true;

    const contextValue = {
        // App-level data
        allPropertyAssociations: propertyAssociations,
        isAdmin: isAdmin,
        isGuest: isGuest,

        // Property-level defaults (not set yet)
        allAreas: [],
        currentPropertyAssociation: undefined,
        currentPropertyAssociationId: '',
        currentArea: undefined,
        currentFunctionPermissions: undefined,
        currentPropertyOwner: undefined,
        isRBHyr: false,
    };

    return (
        <PropertyAssociationProvider value={contextValue}>
            <Navigation />
            <MobileNavigation />
            <SubscriptionBanner />
            <Outlet />
        </PropertyAssociationProvider>
    );
};
